/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Profile Photo editor javascript for settings page
//
// Primarily just a form handler to auto submit the chosen photo
namespace('Slzr.Theme.SettingsProfilePhoto', function(exports, top) {
  let $;
  const jQuery = ($ = Slzr.jQuery);

  return $(function() {
    if (!($('[data-profile-photo]').length > 0)) { return; }

    return $('input[data-profile-photo="file-input"]').on('change', function(event) {
      return $(this).closest('form[data-profile-photo="form"]').submit();
    });
  });
});